import { Ajax } from "./ajax";
import { Notifications } from "./notifications";
import { AddressMap } from "./address-map";
export class AddAddress {
    constructor(modal, form) {
        this.modal = modal;
        this.form = form;
        if (this.modal !== null) {
            this.reloadSelectOnAddressAdded();
            this.setupAjaxSubmit();
        }
        this.form.addEventListener("submit", (ev) => {
            if (!this.map.reportValidity()) {
                ev.preventDefault();
            }
        });
        this.map = AddressMap.initialize(this.form);
    }
    reloadSelectOnAddressAdded() {
        jQuery(this.modal).on("shown.bs.modal", () => {
            this.modal
                .querySelectorAll("select.select2")
                .forEach((element) => {
                jQuery(element).trigger("select2:re-initialize");
            });
        });
    }
    setupAjaxSubmit() {
        const addAddressButton = this.modal?.querySelector(AddAddress._saveButtonSelector);
        if (addAddressButton === null) {
            return;
        }
        this.preventFormSubmit();
        addAddressButton.addEventListener("click", () => {
            if (!this.map.reportValidity() || !this.form.reportValidity()) {
                return;
            }
            const formData = new FormData(this.form);
            const ajax = new Ajax(this.form.action, this.form.method);
            ajax.data = formData;
            ajax.successCallback = (data) => {
                Notifications.success(data.message);
                this.hideModal();
            };
            ajax.errorCallback = () => this.hideModal();
            ajax.send();
        });
    }
    hideModal() {
        this.form.reset();
        if (this.modal !== null) {
            jQuery(this.modal).modal("hide");
        }
    }
    preventFormSubmit() {
        this.form.addEventListener("submit", (ev) => {
            ev.preventDefault();
        });
    }
    static initialize() {
        const addAddressForm = document.querySelector(this._formSelector);
        const modal = document.querySelector(".js-add-address-modal");
        if (addAddressForm === null) {
            return;
        }
        new AddAddress(modal, addAddressForm);
    }
}
AddAddress._formSelector = "form.js-save-address-form";
AddAddress._saveButtonSelector = ".js-add-address-button";
